<template>
    <div v-if="isShow" style="width:100%; min-height:800px; height: auto; margin-top:1px; background-color: white">
        <div class="image">
            <div class="head-imgage">
                <div class="hovera">
                    <span @click="ClickToBack" class="hoverr">赛事首页</span> / 
                    <span class="hoverr">当前比赛</span>
                </div>
                <div style="color:white; font-size: 30px; padding-top: 20px;">
                    AL-{{ compete.title }}
                    
                </div>
                <div style="color:white; font-size: 14px; padding-top: 20px;">{{ compete.startTime }} 至 {{ compete.closeTime }}</div>
                <div style="color:white; font-size: 14px; padding-top: 0px;">时长: {{ time }}</div>
                <div style="color:white; font-size: 14px; padding-top: 12px;">已有 {{ compete.participant }} 人报名</div>
                <div style="position: fixed; top: 100px; right: 200px; color: white; font-size: 16px;">
                    距离比赛结束还有:
                    <el-statistic
                        :value-style="objDeadline"
                        ref="statistic"
                        @finish="hilarity"
                        format="HH:mm:ss"
                        :value="deadline"
                        time-indices
                    >
                    </el-statistic>
                </div>
            </div>
        </div>
        <div class="body">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" >
                <el-menu-item index="1" style="width: 100px; text-align: center; font-size: 16px;">
                    竞赛详情
                </el-menu-item>
                <el-menu-item index="2" style="width: 100px; text-align: center; font-size: 16px;">
                    题目
                </el-menu-item>
                <el-menu-item index="3" style="width: 100px; text-align: center; font-size: 16px;">
                    提交
                </el-menu-item>
                <el-menu-item index="4" style="width: 100px; text-align: center; font-size: 16px;">
                    排名
                </el-menu-item>
                <!-- <el-menu-item index="5" style="width: 100px; text-align: center; font-size: 16px;">
                    题解
                </el-menu-item> -->
            </el-menu>
            <router-view style="margin-top: 20px;"></router-view>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import Url from '@/constant/Url'
    export default {
        name:'ContestPage',
        data() {
            return {
                activeIndex: '',
                isShow:false,
                time:'',
                compete:{},

                deadline: null,
                objDeadline: {
                    color: "white"
                }
            }
        },
        created() {
            // this.$router.push({
            //     path:`/contestPage/${this.$route.params.id}/competeProblem`
            // })
            const vue = this
            const route = this.$route
            $.ajax({
                url: Url.rOneCompeteUrl,
                type:'post',
                data: {
                    id: route.params.id
                },
                success(resp) {
                    if (resp.error_message === "success") {
                        vue.compete = JSON.parse(resp.compete)
                        vue.time = resp.time
                        vue.isShow = true

                        const dateString = vue.compete.closeTime
                        let parts = dateString.split(' '); // 分割日期和时间部分
                        let datePart = parts[0]; // 日期部分
                        let timePart = parts[1]; // 时间部分

                        let dateParts = datePart.split('-'); // 分割年、月、日
                        let timeParts = timePart.split(':'); // 分割时、分、秒

                        // 构建日期对象
                        vue.deadline = new Date(
                            parseInt(dateParts[0]), // 年
                            parseInt(dateParts[1]) - 1, // 月（注意月份是从0开始的，所以要减1）
                            parseInt(dateParts[2]), // 日
                            parseInt(timeParts[0]), // 时
                            parseInt(timeParts[1]), // 分
                            parseInt(timeParts[2]) // 秒
                        );
                    }
                }
            })
        },
        mounted() {
            if (this.$route.path === `/contestPage/rank/${this.$route.params.id}`) this.activeIndex = "4"
            else if (this.$route.path === `/contestPage/notes/${this.$route.params.id}`) this.activeIndex = "5"
            else if (this.$route.path === `/contestPage/submit/${this.$route.params.id}`) this.activeIndex = "3"
            else if (this.$route.path === `/contestPage/competeProblem/${this.$route.params.id}`) this.activeIndex = "2"
            else this.activeIndex = "1"
        },
        methods: {
            hilarity() {
                // this.$notify({
                // title: "提示",
                // message: "时间已到",
                // duration: 0,
                // });
            },
            ClickToBack() {
                this.$router.push("/sweepstakes")
            },
            handleSelect(key, keyPath) {
                console.log(key, keyPath);
                if (key === '1') {
                    if (this.$route.path !== `/contestPage/statement/${this.$route.params.id}`)
                    this.$router.push(`/contestPage/statement/${this.$route.params.id}`)
                } 
                else if (key === '2') {
                    if (this.$route.path !== `/contestPage/competeProblem/${this.$route.params.id}`)
                    this.$router.push(`/contestPage/competeProblem/${this.$route.params.id}`)
                } 
                else if (key === '3') {
                    if (this.$route.path !== `/contestPage/submit/${this.$route.params.id}`)
                    this.$router.push(`/contestPage/submit/${this.$route.params.id}`)
                } 
                else if (key === '4') {
                    if (this.$route.path !== `/contestPage/rank/${this.$route.params.id}`)
                    this.$router.push(`/contestPage/rank/${this.$route.params.id}`)
                } 
                else {
                    if (this.$route.path !== `/contestPage/notes/${this.$route.params.id}`)
                    this.$router.push(`/contestPage/notes/${this.$route.params.id}`)
                }
            },
        }
    }
</script>

<style scoped>
.hoverr {
    cursor: pointer;
}
.hoverr:hover {
    color:white;
}
.head-imgage {
    margin:0 auto;
    width:800px;
    min-height: 300px;
    height: auto;
    font-size: 15px;
}
.hovera {
    padding-top: 20px;
    font-size: 15px;
    height: 40px;
    color: #999999;
}
.hoverb {
    color: white;
    text-decoration: none;
}
.body {
    margin: 15px auto;
    width:900px;
    min-height: 500px;
    height: auto;
    font-size: 15px;
}
.image {
    background-color: white;
    background-image: url('../../assets/image/js.jpg');
    background-size: cover;
    height: 300px;
    text-decoration: none;
}
</style>